"use strict";

const IndcomFacilityPopup = function () {
  var getPopupHtml = function (data) {
    var properties = {
      ...data,
      headerColorClass: getBackgroundColorClass(data),
    };
    properties.permissions = UserPermissions.getAllPermissions();
    return PopupContent.getLayerPopup(properties, "indcomFacilities");
  };

  var getIndcomFacilityPopupData = async function (id) {
    const popupData = await ApiCalls.getFacilityPopupData(id);
    return popupData;
  };

  var getBackgroundColorClass = function (data, isTodo = false) {
    const color = getColor(data, isTodo);

    return `background-${color}`;
  };

  var getColor = function (data, isTodo = false) {
    let color = "grey";

    if (Tree.get(["filters", "conditionPhaseToggle"]) === "phase" && !isTodo) {
      color = getPhaseColor(data.facilityPhase);
    } else {
      if (data.indcomFacilityInspection?.isDue) {
        color = "blue";
      } else if (data.hasInspections) {
        if (data.hasOpenFindings) {
          color = "red";
        } else {
          color = "green";
        }
      } else {
        color = "grey";
      }
    }

    return color;
  };

  var getPhaseColor = function (phase) {
    if (phase === "closed") {
      return "black";
    } else {
      return "white";
    }
  };

  var onPopupOpenWithData = function (data, $element, invalidateLayerDataFunction) {
    var onPopupDelete = function () {
      Analytics.sendPopupEvent("delete_facility", "indcom");
      deleteFacility(data.id, data.facilityName, invalidateLayerDataFunction);
    };

    $element.off("click", ".popup-delete-button", onPopupDelete);
    $element.on("click", ".popup-delete-button", onPopupDelete);

    $element.off("click", ".show-facility-inventory");
    $element.on("click", ".show-facility-inventory", function () {
      const idFacility = $(this).data("idFacility");
      Analytics.sendPopupEvent("view_inventory", "indcom");
      IndcomInventoryModalController.invokeIndcomInventoryModal(idFacility);
    });

    $element.off("click", ".open-fact-sheet-facility");
    $element.on("click", ".open-fact-sheet-facility", function () {
      const id = $element.find(".popup-general").data("id");
      UrlRoutes.go("facility-fact-sheet", { id });
      Analytics.sendPopupEvent("view_details", "indcom");
    });
  };

  var deleteFacility = function (id, name, invalidateLayerDataFunction) {
    MessageModal.showConfirmWarningModal(
      `Delete Facility ${name}? Click "Delete" to permanently delete the Facility. Click "Cancel" to return.`,
      async function () {
        await ApiCalls.deleteFacilityFactSheet(id);
        invalidateLayerDataFunction();
        closePopup();
      },
      "Cancel",
      "Delete",
    );
  };

  var closePopup = function () {
    const closeButton = $(".leaflet-popup-close-button");
    if (closeButton.length > 0) {
      closeButton[0].click();
    }
  };

  var loadPopupPhotosAndFiles = function (id) {
    PopupPhotos.load("indcomFacilities", id);
  };

  var loadFacilityHistory = function (historyData) {
    FacilityHistory.renderFacilityHistory(historyData);
  };

  var onPopupOpen = async function (properties) {
    const id = properties.id;
    var data = await getIndcomFacilityPopupData(id);
    const html = getPopupHtml(data);
    const $popup = $(".leaflet-popup-content");
    $popup.html(html);
    var layerName = "indcomFacilities";
    const layerModule = LayerFunctions.getLayerModule(layerName);
    loadFacilityHistory(data.history);
    renderBarGraph(data?.inspectionsForBarGraph);
    onPopupOpenWithData(data, $popup, layerModule.invalidateLayerData);
    loadPopupPhotosAndFiles(id);
  };

  var renderBarGraph = function (arrayForBarGraph) {
    PopupContent.setPopupConditionBar($(`.tr-indcome-score`), arrayForBarGraph, function (datum) {
      return datum.numericScore;
    });
  };

  return {
    getPopupHtml,
    onPopupOpen,
    getIndcomFacilityPopupData,
    getBackgroundColorClass,
    getColor,
    getPhaseColor,
    renderBarGraph,
  };
};

module.exports = IndcomFacilityPopup();

const ApiCalls = require("../apiCalls");
const FacilityHistory = require("./facilityHistory");
const Tree = require("../tree");
const PopupContent = require("../mapFunctions/popupContent");
const LayerFunctions = require("../layerFunctions");
const MessageModal = require("../modals/messageModal");
const PopupPhotos = require("../mapFunctions/popupPhotos");
const UserPermissions = require("../login/userPermissions");
const Analytics = require("../general/analytics");
const IndcomInventoryModalController = require("./indcomInventoryModalController");
const UrlRoutes = require("../routes/urlRoutes");
